<!-- iOS Install Prompt Banner -->
<div *ngIf="showPrompt"
    class="fixed bottom-5 left-4 right-4 z-50 bg-white dark:bg-dark-secondary rounded-2xl shadow-lg border border-gray-200 dark:border-dark-border p-4 animate-slideUp">

    <div class="flex items-start gap-3">
        <!-- App icon -->
        <div class="w-12 h-12 bg-brand-dark rounded-xl flex items-center justify-center flex-shrink-0">
            <img src="assets/icons/icon-192x192.png" alt="Fina Logo" class="w-full h-full object-cover rounded-xl">
        </div>

        <!-- Text -->
        <div class="flex-1 min-w-0">
            <h3 class="text-sm font-semibold text-gray-900 dark:text-dark-text">
                {{ TEXT.IOS_INSTALL.TITLE }}
            </h3>
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                Tocá
                <span class="material-symbols-rounded text-[14px] align-middle text-cyan-500">ios_share</span>
                y luego "Agregar a Inicio" para usar Fina como una app.
            </p>
        </div>

        <!-- Close -->
        <button (click)="dismiss()"
            class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors flex-shrink-0">
            <span class="material-symbols-rounded text-xl">close</span>
        </button>
    </div>

    <button (click)="dismiss()"
        class="w-full mt-3 text-xs text-gray-400 dark:text-gray-500 hover:text-gray-600 transition-colors">
        {{ TEXT.IOS_INSTALL.DISMISS }}
    </button>
</div>